import React, { useState } from "react";
import { receiveCargoItemPackages } from "../../../resource";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import FirstMileIncomingOrdersContainer from "./FirstMileIncomingOrdersContainer";
import { useSnackbar } from "notistack";
import useShipmentConcept from "../../../component/hook/useShipmentConcept";

const useStyles = makeStyles(({ palette }) => ({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
  },
  dialogPaper: {
    height: "80vh",
    minWidth: "80vw",
  },
  abort: {
    background: palette.status.danger,
    color: "white",
    "&:hover": {
      background: palette.status.danger,
      color: "white"
    }
  },
}));


const FirstMileIncomingOrdersDialog = ({
  open,
  handleClose,
  handleSubmit,
  warehouse
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [incomingOrders, setIncomingOrders] = useState([]);
  const [selectedIncomingOrders, setSelectedIncomingOrders] = useState([]);
  const { setShipment } = useShipmentConcept();

  const handleSubmitIncomingOrders = () => {
    if (!selectedIncomingOrders.length) {
      enqueueSnackbar(t("incomingOrders.noSelection", { variant: "error" }));
    } else {
      setShipment({
        incomingOrderIds: selectedIncomingOrders.map(({ id }) => id),
        incomingOrders: selectedIncomingOrders,
        fresh: true
      });
      history.push("shipment");
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>
        <>Naplánování svozu na sklad</>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <FirstMileIncomingOrdersContainer
          setIncomingOrders={setIncomingOrders}
          incomingOrders={incomingOrders}
          warehouse={warehouse}
          setSelectedIncomingOrders={setSelectedIncomingOrders}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FirstMileIncomingOrdersDialog;